import {
  InteractionRequiredAuthError,
  type AccountInfo,
} from '@azure/msal-browser';
import { msalInstance } from './msalConfig';

/**
 * Acquire a delegated access token for a specific scope set (§4 incremental consent).
 *
 * Silent-first; falls back to an interactive popup only when the tenant/admin has not
 * yet consented to these particular scopes. This is what makes per-module consent work.
 */
export async function acquireToken(scopes: readonly string[]): Promise<string> {
  const account = getActiveAccount();
  if (!account) {
    throw new Error('No signed-in account. Connect to a tenant first (C1).');
  }

  const request = { scopes: [...scopes], account };

  try {
    const result = await msalInstance.acquireTokenSilent(request);
    return result.accessToken;
  } catch (err) {
    if (err instanceof InteractionRequiredAuthError) {
      // New scope the admin hasn't consented to yet — prompt, scoped to just this ask.
      const result = await msalInstance.acquireTokenPopup(request);
      return result.accessToken;
    }
    throw err;
  }
}

export function getActiveAccount(): AccountInfo | null {
  const active = msalInstance.getActiveAccount();
  if (active) return active;
  const [first] = msalInstance.getAllAccounts();
  if (first) {
    msalInstance.setActiveAccount(first);
    return first;
  }
  return null;
}
